import { ArrowUpRightIcon, ChevronDownIcon } from "@heroicons/react/20/solid";
import Link from "next/link";
import { ComponentPropsWithoutRef, FC, ReactElement } from "react";
import { useMessages } from "../context/i18n";
import { nav as enNav } from "../dictionaries/en/nav";
import Button from "./Button";
import DropdownMenu from "./DropdownMenu";
import { DISCORD_LINK } from "./Nav";

type ResourcesNavProps = {} & ComponentPropsWithoutRef<"div">;

type ResourcesNavItem = {
  label: string;
  href: string;
  target?: string;
  rel?: string;
  trailing?: ReactElement;
};

const ResourcesNav: FC<ResourcesNavProps> = ({ ...rest }) => {
  const m = useMessages("nav", enNav);
  const DEV_RESOURCES_NAV_ITEMS: ResourcesNavItem[] = [
    {
      label: m.api,
      href: "/api",
    },
  ];
  const CONTENT_RESOURCES_NAV_ITEMS: ResourcesNavItem[] = [
    {
      label: m.blog,
      href: "/blog",
    },
  ];

  const SOCIAL_RESOURCES_NAV_ITEMS: ResourcesNavItem[] = [
    {
      label: m.discord,
      href: DISCORD_LINK,
      target: "_blank",
      rel: "noreferrer",
      trailing: <ArrowUpRightIcon />,
    },
  ];

  const PARTNERSHIP_RESOURCES_NAV_ITEMS: ResourcesNavItem[] = [
    {
      label: m.affiliate,
      href: "/affiliate",
    },
  ];

  return (
    <div {...rest} className={`${rest.className} relative group`}>
      <DropdownMenu
        containerClassName="w-48"
        align="start"
        positions={["bottom"]}
      >
        <DropdownMenu.Trigger>
          <Button variant="tertiary" size="m" align="start">
            {m.resources} <ChevronDownIcon />
          </Button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content>
          {({ close }) => (
            <div>
              <ul>
                {CONTENT_RESOURCES_NAV_ITEMS.map((item) => (
                  <li key={item.label}>
                    <Link href={item.href} target={item.target} rel={item.rel}>
                      <Button
                        onClick={close}
                        variant="tertiary"
                        size="m"
                        align="start"
                        className="w-full"
                      >
                        {item.label}
                        {item.trailing}
                      </Button>
                    </Link>
                  </li>
                ))}
              </ul>

              {/* <hr className="h-px bg-slate-200 border-transparent mx-4 rounded-full my-1.5" /> */}
              <ul>
                {PARTNERSHIP_RESOURCES_NAV_ITEMS.map((item) => (
                  <li key={item.label}>
                    <Link href={item.href} target={item.target} rel={item.rel}>
                      <Button
                        onClick={close}
                        variant="tertiary"
                        align="start"
                        size="m"
                        className="w-full"
                      >
                        {item.label}
                        {item.trailing}
                      </Button>
                    </Link>
                  </li>
                ))}
              </ul>
              {/* <hr className="h-px bg-slate-200 border-transparent mx-4 rounded-full my-1.5" /> */}
              <ul>
                {DEV_RESOURCES_NAV_ITEMS.map((item) => (
                  <li key={item.label}>
                    <Link href={item.href} target={item.target} rel={item.rel}>
                      <Button
                        onClick={close}
                        variant="tertiary"
                        size="m"
                        align="start"
                        className="w-full"
                      >
                        {item.label}
                        {item.trailing}
                      </Button>
                    </Link>
                  </li>
                ))}
              </ul>
              {/* <hr className="h-px bg-slate-200 border-transparent mx-4 rounded-full my-1.5" /> */}
              <ul>
                {SOCIAL_RESOURCES_NAV_ITEMS.map((item) => (
                  <li key={item.label}>
                    <a href={item.href} target={item.target} rel={item.rel}>
                      <Button
                        onClick={close}
                        variant="tertiary"
                        size="m"
                        align="start"
                        className="w-full"
                      >
                        {item.label}
                        {item.trailing}
                      </Button>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </DropdownMenu.Content>
      </DropdownMenu>
    </div>
  );
};

export default ResourcesNav;
